/* eslint-disable */
import * as React from "react";
import OrbitIcon from "../Icon";
export default function Alert(props) {
  var color = props.color,
      size = props.size,
      customColor = props.customColor,
      className = props.className,
      dataTest = props.dataTest,
      ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      reverseOnRtl = props.reverseOnRtl;
  return React.createElement(OrbitIcon, {
    viewBox: "0 0 24 24",
    size: size,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    d: "M13.609 3.247l8.191 15.8c.1.2.2.5.2.8 0 1-.8 1.8-1.798 1.8H3.719c-.3 0-.5-.1-.8-.2-.799-.5-1.198-1.5-.699-2.4a14906.64 14906.64 0 0 1 8.292-15.8c.331-.622.868-.889 1.481-.897.614-.008 1.273.28 1.616.897zM12 18.95a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6zm-.89-10.203v5.4c0 .5.4.9.9.9s.9-.4.9-.9v-5.3c0-.5-.4-.9-.9-.9s-.9.4-.9.8z"
  }));
}